import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Tab, useTabsStore } from "../../../stores/TabsStore";
import { Button } from "../../../ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../ui/Dialog";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import OneSelector, { Option } from "../../../ui/OneSelector/OneSelector";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { useFetch } from "../../../hooks/useFetch";
import { TbDeviceFloppy } from "react-icons/tb";
import { nanoid } from "nanoid";
import { CustomReport } from "../../../types/types";

const reportSaveBlockTypes = [
  { value: "link", label: "Ссылка" },
  { value: "site", label: "Сайт" },
  { value: "owner", label: "Владелец" },
];

const ReportSaveForm = ({ tab }: { tab: Tab }) => {
  const [open, setOpen] = useState(false);

  const methods = useForm({
    defaultValues: {
      name: tab.options?.savedTabData?.name ? tab.options?.savedTabData?.name : "",
      title: tab.options?.savedTabData?.title ? tab.options?.savedTabData.title : "",
      access_type: tab.options?.savedTabData?.access_type
        ? { value: tab.options?.savedTabData?.access_type, label: t(tab.options?.savedTabData?.access_type) }
        : { value: "", label: "" },
    },
  });
  const { control, watch, handleSubmit, reset } = methods;
  const addOptions = useTabsStore().addOptions;

  const [{ response, isLoading }, doFetchBlocks] = useFetch(`/directories/custom_data_storages`);

  useEffect(() => {
    if (!response) return;
    const responseData = response.data as unknown as CustomReport;
    addOptions(tab.id, {
      ...tab.options!,
      savedTabData: {
        name: responseData.attributes.name,
        title: responseData.attributes.title,
        access_type: responseData.attributes.access_type,
      },
    });
  }, [response]);

  const onNewSaveSubmit = (formData: any) => {
    const savedData = {
      default_values: tab.defaultValues,
      type: tab.type,
      options: {
        blocks: tab.options?.blocks,
        filters: tab.options?.filters,
        params: tab.options?.params,
        report_type: tab.options?.report_type,
      },
      title: tab.title,
      url: tab.url,
    };

    doFetchBlocks({
      method: "POST",
      data: {
        data: {
          name: nanoid(10),
          title: formData.title,
          data: savedData,
          access_type: formData.access_type.value,
          //expires_at: "22.05.2025",
        },
      },
    });

    setOpen(false);
  };

  const [{ response: updateResponse, isLoading: updateIsLoading }, doFetchUpdateBlocks] = useFetch(
    `/directories/custom_data_storages`
  );

  const onUpdateSubmit = (formData: any) => {
    const savedData = {
      default_values: tab.defaultValues,
      type: tab.type,
      options: {
        blocks: tab.options?.blocks,
        filters: tab.options?.filters,
        params: tab.options?.params,
        report_type: tab.options?.report_type,
      },
      title: tab.title,
      url: tab.url,
    };

    doFetchUpdateBlocks({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          title: formData.title,
          data: savedData,
          access_type: formData.access_type.value,
          //expires_at: "22.05.2025",
        },
      },
    });

    setOpen(false);
  };

  useEffect(() => {
    if (open)
      reset({
        name: tab.options?.savedTabData?.name ? tab.options?.savedTabData?.name : "",
        title: tab.options?.savedTabData?.title ? tab.options?.savedTabData.title : "",
        access_type: tab.options?.savedTabData?.access_type
          ? { value: tab.options?.savedTabData?.access_type, label: t(tab.options?.savedTabData?.access_type) }
          : { value: "", label: "" },
      });
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant={"ghost"} size={"datepicker"} className="gap-2">
          <TbDeviceFloppy size={16} /> {t('save')}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] sm:min-w-[600px] p-0">
        <form onSubmit={handleSubmit(onNewSaveSubmit)}>
          <DialogHeader className="px-6 border-b py-6">
            <DialogTitle>Сохранение отчёта</DialogTitle>
            <DialogDescription>Выберите название отчёта и доступ</DialogDescription>
          </DialogHeader>
          <ScrollArea className="w-full h-[300px]">
            <div className="flex flex-col w-full gap-4 py-4 h-full px-6">
              <Controller
                name="title"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={t("report_title")} />
                  </div>
                )}
              />
              <Controller
                name="access_type"
                control={control}
                rules={{ required: true }}
                render={({ field: { value, onChange } }) => (
                  <>
                    <div className="flex justify-between items-center">
                      <Label>{t("choose_report_access")}</Label>
                    </div>
                    <OneSelector
                      value={value ? value : undefined}
                      onChange={(e) => onChange(e)}
                      defaultOptions={reportSaveBlockTypes!}
                    />
                  </>
                )}
              />
              {/* <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input disabled {...field} label={t("report_id")} />
                  </div>
                )}
              /> */}
            </div>
          </ScrollArea>
          <DialogFooter className="px-6 py-6 flex items-center border-t">
            {tab.options?.savedTabData && ( // Проверка на то, импортирована ли вкладка или создана вручную
              <Button type="button" size="sm" onClick={handleSubmit(onUpdateSubmit)}>
                Обновить
              </Button>
            )}
            <Button type="submit" size="sm">
              Сохранить как новый отчёт
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ReportSaveForm;
